<template>
  <div v-if="type == 'texteditor'">
    <label>{{ placeholder }}</label>
    <span v-if="required" class="red-color">*</span>
    <VueEditor @change="$emit('change', myvalue)" v-model="myvalue" />
    <!-- <textarea class="form-control" :class="classes" :placeholder="placeholder" v-model="myvalue" rows="4"
      @input="$emit('input', myvalue)" @change="$emit('change', myvalue)"></textarea> -->
  </div>
  <div v-else-if="type == 'textarea'">
    <label>{{ placeholder }}</label>
    <span v-if="required" class="red-color">*</span>
    <textarea class="form-control" :class="classes" :placeholder="placeholder" v-model="myvalue" rows="4"
      @input="$emit('input', myvalue)" @change="$emit('change', myvalue)"></textarea>
  </div>
  <div v-else-if="type == 'file'">
    <label>{{ placeholder }}</label>
    <span v-if="required" class="red-color">*</span>
    <input class="form-control" :class="classes" @change="onFileChange" type="file" :placeholder="placeholder">
    <div v-if="image" class="imageHolder">
      <img :src="image" />
      <i @click="removeImage" class="fa fa-times"></i>
    </div>
  </div>
  <div v-else-if="type == 'switch'" class="form-check form-switch">
    <input class="form-check-input" type="checkbox" @change="$emit('input', myvalue)" v-model="myvalue">
    <label class="form-check-label" :class="classes">{{ placeholder }}</label>
    <span v-if="required" class="red-color">*</span>
  </div>
  <div v-else>
    <label>{{ placeholder }}</label>
    <span v-if="required" class="red-color">*</span>
    <input class="form-control" :class="classes" :disabled="disabled" :type="type" v-model="myvalue"
      @input="$emit('input', myvalue)" @change="$emit('change', myvalue)" :placeholder="placeholder">
  </div>
</template>
<script>
import $ from 'jquery'
import { VueEditor } from "vue2-editor";
export default {
  props: {
    placeholder: {
      type: String,
      required: false,
    },
    isRequired: {
      required: false,
      default: false
    },
    disabled: {
      required: false,
      default: false
    },
    classes: {
      required: false,
      default: ''
    },
    icon: {
      required: false,
      default: ''
    },
    type: {
      required: false,
      default: 'text'
    },
    required: {
      required: false,
      default: ''
    },
    value: {
      required: false,
      default: ''
    },
    folder: {
      required: false,
      default: ''
    }
  },
  data() {
    return {
      // id: this.type+this.randomFix(5),
      myvalue: this.value,
      image: ''
    }
  },
  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.createImage(files[0]);
    },
    createImage(file) {
      // var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        vm.image = e.target.result;
        console.log(vm.image)
        this.$emit("input", e.target.result);
      };
      reader.readAsDataURL(file);
    },
    saveFile(base64path, filename) {
      $.ajax({
        "method": 'POST',
        "url": this.URL_ROOT + 'admin/savemedia',
        "data": {
          file: base64path,
          name: filename,
          folder: this.folder
        },
        "success": (response) => {
          console.log(response);
        }
      })
    },
    removeImage: function () {
      this.image = '';
      this.$emit("input", '');
      $('#' + this.id).val('');
    }
  },
  watch: {
    value: function (val) {
      this.myvalue = val
    }
  },
  components: { VueEditor }
}
</script>
<style scoped>
.imageHolder img {
  height: 84px;
}

.imageHolder {
  position: absolute;
  top: 0;
  right: 0;
}

.imageHolder i {
  position: absolute;
  z-index: 3;
  right: 8px;
  font-size: 38px;
  cursor: pointer;
  text-shadow: 3px 3px 8px #000;
  color: #f00;
}
</style>
